import { frontendURL } from '../../../helper/URLHelper';
import KanbanRouteGate from './KanbanRouteGate.vue';
import { routes as engineRoutes } from 'kanban/routes';

const gateRoutes = engineRoutes.map(route => ({
  ...route,
  component: KanbanRouteGate,
  props: { view: route.component },
}));

export const routes = [
  {
    path: frontendURL('accounts/:accountId/kanban'),
    name: 'kanban_view',
    redirect: to => ({
      name: 'kanban_list',
      params: { accountId: to.params.accountId },
    }),
  },
  ...gateRoutes,
];
